<template>
  <div class="renew-modal-purchase__container">
    <div class="renew-modal-purchase__header">
      <h2 class="renew-modal-purchase__title">
        Purchase exam voucher
      </h2>
      <div class="renew-modal-purchase__info">
        {{ infoText }}
      </div>
    </div>
    <RadioSelectorForm
      :options="items"
      v-bind="{ currentOption }"
      @select-option="toggleOptionSelection"
    />
    <div class="renew-modal-purchase__footer">
      <ModalGenericCartFooter
        show-back-btn
        :showItemsPill="false"
        :cartTotalItems="1"
        :cartTotalAmount="totalPrice"
        :disableBuyBtn="currentOption === null"
        paddingSum="60"
        class="renew-modal-purchase__cart"
        @back-action="goBack"
        @buy-action="goToBuy"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import RadioSelectorForm from '@/components/forms/RadioSelectorForm.vue'
import ModalGenericCartFooter from '@/components/modals/ModalGenericCartFooter.vue'
const { STEPS } = CONSTANTS.CPE

export default {
  name: 'RenewModalPurchase',
  components: { RadioSelectorForm, ModalGenericCartFooter },
  props: {
    items: {
      type: Array,
      required: true,
    },
    infoText: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      currentOption: null,
    }
  },
  computed: {
    ...mapGetters({
      productCertificationVouchers:
        'subscriptions/getProductCertificationVouchers',
      currentAvailablePlans: 'subscriptions/currentAvailablePlans',
      renewalModalStatus: 'cpeProgram/cpeRenewModalStatus',
    }),
    totalPrice() {
      return this.currentOption?.label?.info
    },
  },
  created() {
    this.clearCart()
    this.toggleOptionSelection(this.items[0])
  },
  methods: {
    ...mapActions({
      setRenewModalStep: 'cpeProgram/setRenewModalStep',
      setRenewModalStatus: 'cpeProgram/setRenewModalStatus',
      clearCart: 'shoppingCart/clearCart',
      addProductToShoppingCart: 'shoppingCart/addProductToShoppingCart',
      removeProductFromShoppingCart:
        'shoppingCart/removeProductFromShoppingCart',
    }),
    toggleOptionSelection(option) {
      if (option && option !== null) {
        if (this.currentOption !== null) {
          this.removeProductFromShoppingCart(this.currentOption)
        }
        this.addProductToShoppingCart(option)
        this.currentOption = option
      }
    },
    goBack() {
      this.setRenewModalStep(STEPS.OPTIONS)
    },
    goToBuy() {
      this.setRenewModalStatus({
        step: STEPS.PAYMENT,
        isRenewal: false,
        certification: this.currentOption.id,
        voucher: this.currentOption,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.renew-modal-purchase {
  &__container {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__title {
    font-size: rem(32);
    line-height: rem(40);
    margin: 0;
    text-align: center;
    @include mobile {
      font-size: rem(40);
      line-height: rem(52);
      margin: 0;
    }
  }
  &__info {
    margin-top: 20px;
    color: var(--light-blue-gray);
    font-size: rem(16);
    line-height: rem(24);
    text-align: center;
  }
  &__footer2 {
    margin-top: 60px;
  }
  &__cart {
    position: relative;
    left: -30px;
    bottom: -30px;
  }
}
</style>
